export default "__VITE_ASSET__c181646c__"